"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var icon_1 = __importDefault(require("../../icon"));
/**
 * 带勾选的list, 最多可配置3个
 */
function CheckList(props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var list = props.list, theme = props.theme;
    var showList = list.slice(0, 3);
    function renderLi(name) {
        var iconColor = theme === 'orange' ? '#f37e11' : '#006EFF';
        return (react_1.default.createElement("li", { key: "coupon-list-".concat(name) },
            react_1.default.createElement("div", { className: "li-icon" },
                react_1.default.createElement(icon_1.default, { name: "check", size: 20, color: iconColor })),
            name));
    }
    return react_1.default.createElement("ul", { className: "".concat(classPrefix, "-coupon-list") }, showList === null || showList === void 0 ? void 0 : showList.map(function (l) { return renderLi(l); }));
}
exports.default = CheckList;
//# sourceMappingURL=CheckList.js.map